import React from 'react';
import ItemStateSelect from './ItemStateSelect';

const isValidId = value => Number.isInteger(Number(value)) && Number(value) > 0;

export const getWarehouseSeriesStateOptions = ({ options = [], rowData }) => {
	const currentStateId = Number(rowData?.state_id);
	const currentStateName = rowData?.state_name || 'Estado actual';
	const normalizedOptions = options
		.filter(state => isValidId(state?.id))
		.map(state => {
			const id = Number(state.id);
			return {
				...state,
				id,
				name:
					state.name || (id === currentStateId ? currentStateName : 'Estado'),
			};
		});

	if (
		isValidId(currentStateId) &&
		!normalizedOptions.some(state => state.id === currentStateId)
	)
		return [
			...normalizedOptions,
			{ id: currentStateId, name: currentStateName },
		];

	return normalizedOptions;
};

const WarehouseSeriesStateValue = ({ rowData, field }) => {
	const editor = field.seriesStateEditor || {};
	const options = getWarehouseSeriesStateOptions({
		options: editor.options,
		rowData,
	});
	const isSubmitting = editor.isSubmitting?.(rowData) === true;
	const editable =
		editor.status === 'success' &&
		isValidId(rowData?.id) &&
		isValidId(rowData?.state_id) &&
		typeof editor.onChange === 'function';

	return (
		<ItemStateSelect
			editable={editable}
			isLoading={editor.status === 'loading' || isSubmitting}
			onChange={targetStateId =>
				editor.onChange?.({ rowData, targetStateId: Number(targetStateId) })
			}
			options={options}
			placeholder={rowData?.state_name}
			value={editable ? Number(rowData.state_id) : undefined}
		/>
	);
};

export default WarehouseSeriesStateValue;
